import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  createSoa: function (soa) {
    soa.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.post('soa', soa)
  },
  createSoaInvoiceProforma: function (invoice) {
    invoice.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.post('soa/invoice/proforma', invoice)
  },
  delSoa: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.delete('soa/' + id)
  },
  getSoaInvoice: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.get('soa/invoice/' + id)
  },
  editSoa: function (soa, id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.put('soa/' + id, soa)
  },
  getTotalInvoice: function ({client}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    return instCred.get('soa/invoice/total')
  },
  getSoa: function ({
    client,
    limit = 9999,
    page = 1,
    filter,
    isMiscFilter = false,
    isPaymentFilter = false
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    const withElastic = 'soa?'
    const withoutElastic = 'soa/withoutelastic?'
    const api = /search/.test(filter) ? withElastic : withoutElastic
    const query = `${api}limit=${limit}&page=${page}&sort[]=date&sort[]=-1&client[]=${client}&${filter}`
    let filterIsMisc = ''
    let filterIsPayment = ''
    if (isMiscFilter) filterIsMisc = `&isMisc=${isMiscFilter}`
    if (isPaymentFilter) filterIsPayment = `&isNoPaymentInvoice=${isPaymentFilter}`
    return instCred.get(`${query}${filterIsMisc}${filterIsPayment}`)
  },
  getSoaTotal: function (client) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    return instCred.get('soa/total')
  },
  generateExcel ({body, query = '', client}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    return instCred.post('soa/excel?' + query, body)
  },
  downloadZip ({client, date, balanceAed}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    const query = [`${date}`]
    return instCred.get('soa/downloadzip?' + query.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Soa/api.js